import React from "react";
import "../styles/Section.css";

const tech = ["React", "Node.js", "MongoDB", "AWS", "Docker"];

const TechStack = () => {
  return (
    <section className="section">
      <h2>Technology Stack</h2>
      <div className="cards">
        {tech.map((item, index) => (
          <div key={index} className="card animate">
            <h3>{item}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TechStack;